export default __webpack_public_path__ + "static/media/21M.59feabbd.jpeg";